<div class="chip"
     *ngIf="!newElementInput; else editionTemplate"
     [ngClass]="{clickable: !readOnly,
                                alarm: type === 'alarm',
                                operator: type === 'operator',
                                disabled: isEdited}"

     (click)="setElementAsEditable()">

    <div *ngIf="!isEdited; else editionTemplate">
        {{element?.name || element}}
    </div>

    <fa-icon [icon]="faTimes"
             *ngIf="isEdited"
             (click)="deleteElement.emit(true)">
    </fa-icon>
</div>

<ng-template #editionTemplate>
    <input type="text" matInput label="New alarm" class="basic-input"
           #editionTemplateInput
           [ngClass]="{hasError: hasError, withPadding: newElementInput}"
           [formControl]="autocompleteFormControl"
           [matAutocomplete]="auto"
           [placeholder]="type === 'alarm' ? 'Alarm name' : 'Operator'"
           (blur)="addElementByFocusLoss()"
           (focus)="focusElement.emit(true)"
           (input)="filterElementsByUserInput($event)"
           (keyup.enter)="addElementByKeyboardInput()">
</ng-template>

<mat-autocomplete #auto="matAutocomplete"
                  (optionSelected)="addElementByOptionSelection($event); autocompleteFormControl.reset()">
    <mat-option *ngFor="let element of userFilteredElementsObs | async"
                [value]="element">
        {{element?.name || element}}
    </mat-option>
</mat-autocomplete>
